"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCommwebService = void 0;
const axios_1 = __importDefault(require("axios"));
const injection_symbols_1 = require("./injection-symbols");
const enums_1 = require("../../enums");
/**
 * Creates the commweb service composable instance, for use as a plugin in the Vue app.
 */
function createCommwebService(options) {
    var _a;
    const { authenticationService } = options;
    // Axios instance for commercial web microservice calls.
    const client = axios_1.default.create({
        baseURL: options.baseUrl,
        timeout: (_a = options.timeout) !== null && _a !== void 0 ? _a : 70000,
        headers: {
            'Cache-Control': 'no-cache'
        }
    });
    // Intercept request to ensure we are authenticated before making any API call.
    client.interceptors.request.use((config) => __awaiter(this, void 0, void 0, function* () {
        var _b;
        // Re-authenticate if not authenticated
        try {
            if (!(yield authenticationService.isAuthenticated())) {
                yield authenticationService.login();
            }
        }
        catch (error) {
            yield authenticationService.expireSession();
            throw new axios_1.default.Cancel('[commweb-service] Session expired. Canceling request. ' + error);
        }
        // Add authorization headers to request
        config.headers = (_b = config.headers) !== null && _b !== void 0 ? _b : {};
        config.headers['Authorization'] = `Bearer ${yield authenticationService.getAccessToken('commweb')}`;
        config.headers['X-UI-Start-Timestamp'] = new Date().getTime();
        return config;
    }), (error) => {
        return Promise.reject(error);
    });
    // Intercept response to attempt to renew session if status shows as unauthorized (potentiall session expired).
    client.interceptors.response.use((response) => {
        logNetworkResponseToSplunk(response);
        return response;
    }, (error) => __awaiter(this, void 0, void 0, function* () {
        const axiosError = error;
        if (axiosError) {
            const response = axiosError.response;
            if (response) {
                const isAuthenticated = yield authenticationService.isAuthenticated();
                if (isAuthenticated && response.status === 419) {
                    yield authenticationService.refreshSession();
                }
            }
            logNetworkResponseToSplunk(response);
        }
        throw error;
    }));
    /**
     * Retrieve the monitoring session id
     */
    function getMonitoringSessionId() {
        return __awaiter(this, void 0, void 0, function* () {
            return authenticationService.getMonitoringSessionId();
        });
    }
    /**
     * Update the options used on service creation.
     */
    function useOptions(options) {
        if (options.baseUrl) {
            client.defaults.baseURL = options.baseUrl;
        }
        if (options.timeout) {
            client.defaults.timeout = options.timeout;
        }
    }
    /**
     * Log the network request details to Splunk for monitoring
     */
    function logNetworkResponseToSplunk(response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!(yield authenticationService.isAuthenticated())
                    || !response
                    || ((_b = (_a = response.config) === null || _a === void 0 ? void 0 : _a.url) === null || _b === void 0 ? void 0 : _b.includes('commservices-eventlog/api/v1/event')))
                    return;
                const elapsedTime = new Date().getTime()
                    - (parseInt(`${(_d = (_c = response.config) === null || _c === void 0 ? void 0 : _c.headers) === null || _d === void 0 ? void 0 : _d['X-UI-Start-Timestamp']}`, 10) || 0);
                let path = ((_j = (_g = ((_f = (_e = response.config) === null || _e === void 0 ? void 0 : _e.headers) === null || _f === void 0 ? void 0 : _f['X-UI-Template-Path'])) !== null && _g !== void 0 ? _g : (_h = response.config) === null || _h === void 0 ? void 0 : _h.url) !== null && _j !== void 0 ? _j : '');
                try {
                    path = decodeURI(new URL(path).pathname);
                }
                catch (error) { /* Allow it to log the non-decoded path */ }
                yield client.post(`commservices-eventlog/api/v1/event/${(_k = (yield authenticationService.getConstituent())) !== null && _k !== void 0 ? _k : enums_1.Constituent.MEMBER}`, {
                    message_type: 'network',
                    comm_web_uuid: yield authenticationService.getMonitoringSessionId(),
                    platform: 'mhtk3',
                    timestamp: new Date().toISOString(),
                    elapsed_time: elapsedTime,
                    method: ((_m = (_l = response.config) === null || _l === void 0 ? void 0 : _l.method) !== null && _m !== void 0 ? _m : '').toLowerCase(),
                    origin: ((_o = client.defaults.baseURL) !== null && _o !== void 0 ? _o : '').replace(/\/$/, ''),
                    path: '/' + path.replace(/$\//, ''),
                    status: response.status
                });
            }
            catch (error) {
                // Ignore all errors - monitoring is not mission critical
            }
        });
    }
    // Build the plugin object.
    const commwebService = {
        client,
        getMonitoringSessionId,
        useOptions,
        install(app) {
            app.provide(injection_symbols_1.commwebServiceKey, commwebService);
            app.provide(injection_symbols_1.commwebServiceClientKey, client);
        }
    };
    return commwebService;
}
exports.createCommwebService = createCommwebService;
//# sourceMappingURL=commweb-service.js.map